import { useEffect, Fragment } from 'react';
import { shape, bool } from 'prop-types';
import { Heading, LabelText } from 'shared/components';
import { InputsContainer, FlexContainer } from 'shared/containers';
import { SelectField, TextField, RadioButtonField, CheckboxField, RadioSwitchFields } from 'shared/fields';
import { MONTHS_OPTIONS } from '../../config';
import { css } from '@emotion/react';
import { Info } from 'shared/components';
import { useNavigate } from 'react-router-dom';

const RateTerm = ({ isEndUnknown }) => {
  const navigate = useNavigate();
  useEffect(() => {
    navigate('/hypotheekbespaarcheck/fixed-rate-term');
  }, [navigate]);

  return <>
    <LabelText>
      Wanneer loopt de rentevaste periode af? (vul de eerste datum in als je meerdere leningdelen hebt)
      <Info title="Meerdere leningdelen">
        Soms heeft een hypotheek meerdere leningdelen met verschillende rentes.
        Na onze eerste indicatie, kun je deze informatie aanvullen en krijg je
        een nauwkeuriger berekening.
      </Info>
    </LabelText>
    <FlexContainer>
      <SelectField
        id="fixed_rate_term_end_month"
        name="fixed_rate_term_end_month"
        options={MONTHS_OPTIONS}
        placeholder="Maand"
        disabled={isEndUnknown}
      />
      <TextField placeholder="Jaar" name="fixed_rate_term_end_year" disabled={isEndUnknown} inputMode='numeric'/>
    </FlexContainer>
    <CheckboxField label="Ik weet het niet" id="fixed_rate_term_end_unknown" name="fixed_rate_term_end_unknown" />
    {isEndUnknown && (
      <Fragment>
        <LabelText>Binnen welke termijn denk je dat dit is?</LabelText>
        <div
          css={css`
          margin-top: 14px;
        `}
        >
          <RadioButtonField name="estimated_fixed_rate_term_end" value={24}>
            Binnen 2 jaar
          </RadioButtonField>
          <RadioButtonField name="estimated_fixed_rate_term_end" value={60}>
            Binnen 5 jaar
          </RadioButtonField>
          <RadioButtonField name="estimated_fixed_rate_term_end" value={120}>
            Binnen 10 jaar
          </RadioButtonField>
          <RadioButtonField name="estimated_fixed_rate_term_end" value={240}>
            Binnen 20 jaar
          </RadioButtonField>
        </div>
      </Fragment>
    )}
  </>;
}

const FixedRateTerm = ({ values: { variable_interest_rate, fixed_rate_term_end_unknown } }) => (
  <>
    <Heading>Rentevaste periode</Heading>
      <InputsContainer>
      <LabelText>
        Ik heb een variabele rente
        <Info title="Ik heb een variabele rente">
        Bij een variabele rente kan je rente per maand of kwartaal veranderen.
        </Info>
      </LabelText>
        <RadioSwitchFields name="variable_interest_rate" />
        {!variable_interest_rate && <RateTerm isEndUnknown={fixed_rate_term_end_unknown} />}
      </InputsContainer>
  </>
);

FixedRateTerm.propTypes = {
  values: shape({
    variable_interest_rate: bool,
    fixed_rate_term_end_unknown: bool, 
  }).isRequired,
};

export default FixedRateTerm;
